import { ApiBaseFront } from "../../front/api-base-front";

type PramType = {
  kijshopCd: string,
  purposeId: string,
};

export type OrderEditViewModel = {
  /* セレクト希望枚数 */
  select: boolean,
  /* 備考 */
  remark: boolean,
  /* 色補正 */
  colorFix: boolean,
  /* 1次レタッチオプション */
  firstRetouchOption: boolean,
  /* 1次レタッチ項目ラベル */
  firstRetouchOptionLabel: string,
  /* 1次レタッチオプション必須制御 */
  requiredFirstRetouchOption: boolean,
  /* 結果の画像DL */
  resultDownload: boolean,
  /* 結果の画像DLが必須 */
  requiredResultDownload: boolean,
  /* 商品使用画像 */
  usageImage: boolean,
  /* 商品使用画像レタッチオプション */
  usageImageRetouchOption: boolean,
  /* ワンストップ商品かどうか */
  isOneStop: boolean,
  isOlc: boolean,
  /* TAWレタッチデータ販売用 */
  isRetouch: boolean,
  retouchLabel: string,
  /* プリセット */
  preset: boolean,
  presetLabel: string,
}

export type PurposeDetail = {
  id: string,
  categoryId: number,
  categoryName: string,
  isUsePpm: 0 | 1,
  isLabUserJob: 0 | 1,
  isUploadResult: 0 | 1,
  isDownloadResult: 0 | 1,
  isUseResult: 0 | 1,
  isOneStop: 0 | 1,
  isOlc: 0 | 1,
  isSameImageCount: 0 | 1,
  isRequiredImage: 0 | 1,
  dispItems: OrderEditViewModel,
  submitButtonLabel: string,
  isPfcDownload: 0 | 1,
}

export class ApiCloudFolderPurposeDetailGet extends ApiBaseFront<PurposeDetail> {
  constructor(_param: PramType) {
    const { kijshopCd, purposeId, ...param } = _param;
    super(
      'GET',
      `/api/v1/c-folder/shop/${kijshopCd}/purpose/${purposeId}`,
      'JSON',
      param,
    );
  }
}
